import { z } from 'zod/v4';
import { PerformedBySchema } from '../performed-by/index.js';
export const InteractionTagSchema = z.object({
    id: z.uuid(),
    tenantId: z.uuid(),
    name: z.string(),
    // Interactions carrying a hidden tag are excluded from the default case
    // history view; only a filter targeting one of their tags surfaces them.
    hiddenByDefault: z.boolean(),
    createdAt: z.iso.datetime(),
    createdBy: PerformedBySchema,
});
//# sourceMappingURL=index.js.map